import _ from 'underscore';

export const getLocationsInfo = (locationCriterions) => {
  const getLocationCriterions = isTarget => _.chain(locationCriterions)
    .filter(c => c.SelectionStatus === (isTarget ? 'Included' : 'Excluded'))
    .map(c => c.Criterion.LocationCriterion || c.Criterion.RadiusCriterion)
    .map(c => c.CountryCode)
    .compact()
    .map(c => c.toUpperCase())
    .uniq()
    .value();

  const targetedLocationCriterions = getLocationCriterions(true);
  const excludedLocationCriterions = getLocationCriterions(false);
  const intentOption = _.chain(locationCriterions)
    .filter(c => c.CriterionType === 'LocationIntentCriterion')
    .map(c => c.Criterion.LocationIntentCriterion.IntentOption)
    .compact()
    .first()
    .value() || 'PeopleInOrSearchingForOrViewingPages';

  return {
    locationIntentCriterion: intentOption,
    targetedLocationCriterions,
    excludedLocationCriterions,
  };
};

export const getLocationsInfoFromCampaignCriterions = (campaignCriterions) => {
  // override location criterions
  const locations = _.chain(campaignCriterions)
    .filter(c => c.Criterion && (c.Criterion['@odata.type'] === '#Model.LocationCriterion' || c.Criterion['@odata.type'] === '#Model.RadiusCriterion'))
    .map((c) => {
      const locationCriterion = {};

      locationCriterion.SelectionStatus = c['@odata.type'] && c['@odata.type'].indexOf('Biddable') !== -1 ? 'Included' : 'Excluded';


      if (c.Criterion['@odata.type'] === '#Model.LocationCriterion') {
        locationCriterion.Criterion = {
          LocationCriterion: {
            CountryCode: c.Criterion.CountryCode,
          },
        };
      } else {
        locationCriterion.Criterion = {
          RadiusCriterion: {
            CountryCode: c.Criterion.CountryCode,
          },
        };
      }

      return locationCriterion;
    })
    .value();

  // override intent criterion
  const intent = _.chain(campaignCriterions)
    .filter(c => c.Criterion && (c.Criterion['@odata.type'] === '#Model.LocationIntentCriterion'))
    .map(c => ({
      CriterionType: 'LocationIntentCriterion',
      Criterion: {
        LocationIntentCriterion: {
          IntentOption: c.Criterion.IntentOption,
        },
      },
    }))
    .value();

  return {
    intent,
    locations,
  };
};
